import { render, staticRenderFns } from "./crm.vue?vue&type=template&id=0cb356de&"
import script from "./crm.vue?vue&type=script&lang=js&"
export * from "./crm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb356de')) {
      api.createRecord('0cb356de', component.options)
    } else {
      api.reload('0cb356de', component.options)
    }
    module.hot.accept("./crm.vue?vue&type=template&id=0cb356de&", function () {
      api.rerender('0cb356de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/crm.vue"
export default component.exports